export let subSort = (arr, i, n, sortFx) => [].concat(...arr.slice(0, i), ...arr.slice(i, i + n).sort(sortFx), ...arr.slice(i + n, arr.length))



// WEBPACK FOOTER //
// ./src/_helpers/subsort.js